import React, {useState} from 'react'
import {Button} from 'antd';
import IsolationNumberModal from "./IsolationNumberModal";

function IsolationNumber(props) {
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <Button className="ml-3" onClick={_toggleModal} type="primary">Cô lập</Button>
        {showModal && <IsolationNumberModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default IsolationNumber
